import { FovErrorOption } from '@contentsquare/fov-constants';
import { BaseErrorLabelHelper } from './error-label-base.helper';
export class JSErrorLabelHelper extends BaseErrorLabelHelper {
    constructor(translate) {
        super(translate);
    }
    getJSErrorLabel(errorFilter) {
        const { errorOption } = errorFilter.value;
        const selectedErrorOption = this.getErrorOption(errorFilter);
        const label = selectedErrorOption === null || selectedErrorOption === void 0 ? void 0 : selectedErrorOption.label;
        switch (errorOption) {
            case FovErrorOption.ANY: {
                return `${this.translate(label)}`;
            }
            case FovErrorOption.EXACT: {
                const exactErrorConditionLabel = this.getExactJSErrorConditionLabel(errorFilter);
                return `${this.translate(label)} ${exactErrorConditionLabel}`;
            }
            case FovErrorOption.NAMED: {
                const namedErrorConditionLabel = this.getNamedJSErrorConditionLabel(errorFilter);
                return `${this.translate(label)} ${namedErrorConditionLabel}`;
            }
            case FovErrorOption.GROUPED: {
                const groupedErrorConditionLabel = this.getGroupedJSErrorConditionLabel(errorFilter);
                const partOf = 'ANALYSIS_CONTEXT.ERROR_CONDITION.PART_OF';
                return `${this.translate(partOf)} ${this.translate(label)} ${groupedErrorConditionLabel}`;
            }
        }
    }
    getNamedJSErrorConditionLabel(errorFilter) {
        const { errorMessage } = errorFilter.value;
        return `${this.translate('ANALYSIS_CONTEXT.ERROR_CONDITION.THAT_CONTAINS')} "${errorMessage}"`;
    }
    getExactJSErrorConditionLabel(errorFilter) {
        const { errorMessage, errorFileName, errorLineNumber, errorColumnNumber } = errorFilter.value;
        return (`${this.translate('ANALYSIS_CONTEXT.ERROR_CONDITION.WITH_ERROR_NAME')}` +
            ` "${errorMessage}"` +
            ` ${this.translate('ANALYSIS_CONTEXT.ERROR_CONDITION.AND_FILE_NAME')}` +
            ` ${errorFileName}` +
            ` ${this.translate('ANALYSIS_CONTEXT.ERROR_CONDITION.ON_LINE')}` +
            ` ${errorLineNumber}` +
            ` ${this.translate('ANALYSIS_CONTEXT.ERROR_CONDITION.IN_COLUMN')}` +
            ` ${errorColumnNumber}`);
    }
    getGroupedJSErrorConditionLabel(errorFilter) {
        const { errorGroupId } = errorFilter.value;
        return `${errorGroupId}`;
    }
}
//# sourceMappingURL=error-label-js.helper.js.map